// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WtPt","select":"styles_select__fri6O"};